<div #content>
  <ng-content *ngIf="control.isOpen$ | async"></ng-content>
</div>
